module.exports = __webpack_public_path__ + "static/media/evaluation.0d0fe650.png";